import ImporterDealers from 'components/admin/Importer/ImporterDealers'
import ImporterProducts from 'components/admin/Importer/ImporterProducts'
import CartBrowser from 'components/admin/Carts/CartBrowser.jsx'
import ToDos from 'components/admin/ToDos/ToDos.jsx'
import logo from 'images/logoWhite.svg'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loadCustomerOrders, loadDealerOrders, loadNPS } from 'redux/carts'
import { loadDealerState, loadProductState } from 'redux/importer'
import { cancelConfirm } from 'redux/navigation'
import { loadToDos } from 'redux/toDos'
import { loadUsers } from 'redux/userAdmin'
import { Divider, Grid, Image } from 'semantic-ui-react'
import DashboardTiles from '../../components/admin/Helper/DashboardTiles'
import Greeting from '../../components/admin/Helper/Greeting'
import SyncStatus from '../../components/admin/Helper/SyncStatus'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadDealerState,
      loadProductState,
      loadToDos,
      loadDealerOrders,
      loadCustomerOrders,
      loadUsers,
      loadNPS
    },
    dispatch,
  )
}

class Dashboard extends React.Component {
  componentWillMount() {
    const {
      loadDealerState,
      loadProductState,
      loadToDos,
      loadDealerOrders,
      loadCustomerOrders,
      loadUsers,
      loadNPS
    } = this.props
    loadDealerState()
    loadProductState()
    loadToDos()
    loadDealerOrders()
    loadCustomerOrders()
    loadUsers()
    loadNPS()
  }

  render() {
    return (
      <Grid className="noselect dashboard">
        <Grid.Row>
          <Grid.Column>
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={10}>
                  <Greeting/>
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle">
                  <Image src={logo} fluid style={{ opacity: 0.5 }}/>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={12}>
            <DashboardTiles/>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column tablet={12} computer={12} largeScreen={4} widescreen={5}>
            <Grid>
              <Grid.Row>
                <Grid.Column
                  computer={6}
                  largeScreen={12}
                  className="stacked top up-to-computer">
                  <CartBrowser dashboard kind="dealer_orders"/>
                </Grid.Column>
                <Grid.Column
                  computer={6}
                  largeScreen={12}
                  className="stacked top up-to-computer">
                  <CartBrowser dashboard kind="customer_orders"/>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>

          <Grid.Column tablet={12} computer={12} largeScreen={8} widescreen={7}>
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={12}>
                  <ToDos compact/>
                  <Divider hidden className="compact"/>
                </Grid.Column>
                <Grid.Column width={12}>
                  <SyncStatus/>
                </Grid.Column>
                <Grid.Column width={6}>
                  <ImporterProducts/>
                  <Divider hidden className="compact"/>
                </Grid.Column>
                <Grid.Column width={6}>
                  <ImporterDealers/>
                  <Divider hidden className="compact"/>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

Dashboard = connect(mapStateToProps, mapDispatchToProps)(Dashboard)
export default Dashboard



// WEBPACK FOOTER //
// ./src/containers/admin/dashboard.jsx